import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { Report as ReportType, TranslationKey } from '../../types';
import { BadgeVariant } from '../atoms/Badge/Badge.styles';
import MobileBackButton from '../public/MobileBackButton';
import { TextLink } from '../public/PublicReportCard/PublicReportCard.styles';
import { getEvidenceButtonLabel } from '../public/PublicReportCard/getEvidenceButtonLabel';
import PublicReportDetails from '../public/PublicReportDetails/PublicReportDetails';
import { Bottom, Info, StyledBadge } from './ChatReportSidebar.styles';

interface Props {
  linkToViewReport: boolean;
  organisation: string;
  report: ReportType;
}

const ChatReportSidebar: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  return (
    <Info>
      <MobileBackButton
        backText="public.ChatContainer.backToMessages"
        backTo={`/${props.organisation}/open-reporting/messages`}
      />
      <PublicReportDetails
        organisation={props.organisation}
        reportId={props.report.reportId}
        category={props.report.reportedCategory?.name ?? props.report.type}
        displayId={props.report.displayId}
        status={props.report.status}
        created={props.report.date}
        includeStatus
        sidebar
        evidenceButtonLabel={getEvidenceButtonLabel(
          props.report.source,
          props.report.status,
        )}
      />
      <StyledBadge
        variant={props.report.status.toLowerCase() as BadgeVariant}
        text={t(`ReportStatus.${props.report.status}` as TranslationKey)}
      />
      <Bottom>
        <TextLink
          to={`/${props.organisation}/open-reporting/reports/${props.report.reportId}`}
          data-testid="messages-view-report-link"
        >
          {t('public.PublicReportCard.viewReport')}
        </TextLink>
      </Bottom>
    </Info>
  );
};

export default ChatReportSidebar;
